import React, { useEffect, useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Select from "react-select";
import FiltersComment from "./filterscomment";
import axios from "axios";
import Spinner from "../LoadingSpinner/loadingSpinner";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import api from "../../api";
import { components } from "react-select";
import { Tooltip } from "react-tooltip";

const ContentComments = ({ dataComment, handleAddNewComment }) => {
  const [languageData, setLanguageData] = useState(null);
  const [selectedReview, setSelectedReview] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isAddNew, setIsAddNew] = useState(false);
  const [sortOption, setSortOption] = useState("");
  const [filteredReviews, setFilteredReviews] = useState([]);
  const [expertFilter, setExpertFilter] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [cookieLang, setCookieLang] = useState("");
  const [reviews, setReviews] = useState([]);
  const [totalReviews, setTotalReviews] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [expertList, setExpertList] = useState([]);
  const [expertsLoading, setExpertsLoading] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState(0);
  const clickTimeout = useRef(null);
  const [body, setBody] = useState({
    expert: null,
    comment: "",
    rating: null,
  });
  const initialReviewForm = {
    expert_id: "",
    content: "",
    rating: "",
  };
  const [reviewForm, setReviewForm] = useState(initialReviewForm);

  const limit = 8;
  const totalPages = Math.ceil(totalReviews / limit);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const handleChangeInput = (item, value) => {
    setBody((prev) => ({ ...prev, [item]: value }));
  };

  const fetchExpertsData = async () => {
    try {
      setExpertsLoading(true);

      const response = await api.get(`/content/experts/list`);
      const experts = response?.data?.data ?? [];
      const options = experts.map((expert) => ({
        value: expert.id,
        label: expert.nickname,
        image: expert.image,
      }));
      setExpertList(options);
    } catch (error) {
      console.error(error);
      setExpertList([]);
    } finally {
      setExpertsLoading(false);
    }
  };

  const LoadingSpinner = () => (
    <div className="text-center p-10">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        className="spinner-svg"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M11.5625,1.87499996 C11.5625,2.73792965 10.8629297,3.43749997 10,3.43749997 C9.13707031,3.43749997 8.43749999,2.73792965 8.43749999,1.87499996 C8.43749999,1.01207027 9.13707031,0.312499952 10,0.312499952 C10.8629297,0.312499952 11.5625,1.01207027 11.5625,1.87499996 Z"
        />
      </svg>
    </div>
  );

  useEffect(() => {
    let filtered = [...reviews];
    if (expertFilter) {
      filtered = filtered.filter(
        (review) =>
          (review.expert.nickname || "").toLowerCase() ===
          expertFilter.toLowerCase(),
      );
    }

    if (searchTerm) {
      filtered = filtered.filter((review) =>
        review.expert.nickname.toLowerCase().includes(searchTerm.toLowerCase()),
      );
    }

    if (sortOption === "newest") {
      filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
    } else if (sortOption === "rating") {
      filtered.sort((a, b) => Number(b.rating) - Number(a.rating));
    }

    setFilteredReviews(filtered);
  }, [reviews, expertFilter, sortOption, searchTerm]);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const lang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (lang) {
      setCookieLang(lang);
      import(`../../lang/comments/${lang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    }
  }, []);
  const loadingRef = useRef(false);

  const fetchReviewData = async (page = 1) => {
    if (loadingRef.current) return;
    try {
      loadingRef.current = true;
      setShowSpinner(true);
      const response = await api.get(`/messaging/reviews/load`, {
        params: {
          page,
          limit,
        },
      });
      setReviews(response?.data?.data || []);
      setTotalReviews(response?.data?.total || 0);
    } catch (error) {
    } finally {
      setShowSpinner(false);
      loadingRef.current = false;
    }
  };

  useEffect(() => {
    fetchReviewData(currentPage);
  }, [currentPage]);
  const paginate = (pageNumber) => {
    setShowSpinner(true);
    setCurrentPage(pageNumber);
  };

  const formatDate = (date) => {
    if (!cookieLang) return new Date(date).toLocaleString();

    const formattedDate = new Intl.DateTimeFormat(
      cookieLang === "fr" ? "fr-FR" : "en-US",
      {
              timeZone: "UTC",
year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      },
    ).format(new Date(date));

    const finalDate =
      cookieLang === "en" ? formattedDate.replace(/\//g, "-") : formattedDate;

    return <span>{finalDate}</span>;
  };

  const openModal = (review = null) => {
    setSelectedReview(review);
    setIsAddNew(!review);
    if (!review) {
      setReviewForm(initialReviewForm);
      setRating(0);
    } else {
      setReviewForm({
        expert_id: review.expert?.id || "",
        content: review.content || "",
        rating: review.rating || "",
      });
      setRating(Number(review.rating) || 0);
    }
    setShowModal(true);
    fetchExpertsData();
  };

  const closeModal = () => {
    setShowModal(false);
    setReviewForm(initialReviewForm);
    setRating(0);
    setSelectedReview(null);
    setIsAddNew(false);
    setBody({
      expert: null,
      comment: "",
      rating: null,
    });
  };

  const handleStarHover = (index) => {
    handleChangeInput("rating", index);
  };
  const handleStarClick = (index) => {
    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current);
      clickTimeout.current = null;
      const value = index + 1;
      setRating(value);
      setReviewForm((prev) => ({
        ...prev,
        rating: value,
      }));
      return;
    }

    clickTimeout.current = setTimeout(() => {
      const value = index + 0.5;
      setRating(value);
      setReviewForm((prev) => ({
        ...prev,
        rating: value,
      }));

      clickTimeout.current = null;
    }, 250);
  };

  useEffect(() => {
    setReviewForm((prev) => ({
      ...prev,
      rating,
    }));
  }, [rating]);

  const handleSaveReview = async () => {
    if (!reviewForm.expert_id || !reviewForm.content || !reviewForm.rating) {
      Swal.fire({
        title: languageData?.alert?.title,
        icon: "error",
      });
      return;
    }
    setLoading(true);
    try {
      const response = await api.post(`/messaging/reviews/add`, reviewForm);
      const reviews = response.data.data;
      await fetchReviewData(currentPage);

      closeModal();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
const Control = (props) => (
  <components.Control
    {...props}
    innerProps={{
      ...props.innerProps,
      "data-interaction": "experts_list",
    }}
  />
);

  if (!languageData) {
    return <div></div>;
  }

  return (
    <div>
      <div className="row m-0">
        <FiltersComment
          reviews={reviews}
          filteredReviews={filteredReviews}
          expertFilter={expertFilter}
          searchTerm={searchTerm}
          sortOption={sortOption}
          onFilterChange={(expert) => {
            setShowSpinner(true);
            setExpertFilter(expert);

            setTimeout(() => {
              setShowSpinner(false);
            }, 300);
          }}
          onSortChange={(sort) => {
            setShowSpinner(true);
            setSortOption(sort);

            setTimeout(() => {
              setShowSpinner(false);
            }, 300);
          }}
          onSearchChange={(term) => setSearchTerm(term)}
          /*     onFilterChange={(expert) => setExpertFilter(expert)}
          onSortChange={(sort) => setSortOption(sort)}
           */
          total={totalReviews}
        />

        <div className="col-xl-12 text-start">
          <div className="row g-3 align-items-stretch">
            {showSpinner ? (
              <div className="spinner-overlay">
                <Spinner />
              </div>
            ) : filteredReviews.length === 0 ? (
              <div className="flex flex-column align-items-center justify-content-center">
                <div className="col-12 col-md-6 col-lg-4 d-flex">
                  <a
                    data-interaction="add_comment"
                    className="card flex-fill d-flex align-items-center justify-content-center text-center content_comment"
                    onClick={() => openModal()}
                  >
                    <div className="min-w-31 card-body d-flex flex-column align-items-center justify-content-center">
                      <i className="bi bi-plus-circle"></i>
                      <p className="mt-2 text-primary">{languageData.add}</p>
                    </div>
                  </a>
                </div>
                <div className="no-results d-flex flex-column justify-content-center align-items-center text-center">
                  <i className="ri-chat-heart-line fs-40 grey"></i>
                  <h3 className="text-muted">{languageData.no_comment}</h3>
                  <p className="text-muted">{languageData.find}</p>
                </div>
              </div>
            ) : (
              <>
                <div className="col-12 col-md-6 col-lg-4 d-flex">
                  <div
                    className="content_comment card flex-fill d-flex align-items-center justify-content-center text-center"
                    onClick={() => openModal()}
                  >
                    <div className="min-w-31 card-body d-flex flex-column align-items-center justify-content-center">
                      <i className="bi bi-plus-circle"></i>
                      <p className="mt-2 text-primary">{languageData.add}</p>
                    </div>
                  </div>
                </div>

                {/*  {reviews.map((review) => ( */}
                {filteredReviews.map((review) => (
                  <div
                    key={review.id}
                    className="col-12 col-md-6 col-lg-4 d-flex"
                  >
                    <div className="card flex-fill">
                      <div className="card-body d-flex flex-column justify-content-center">
                        <div className="d-flex align-items-center mb-3">
                          <img
                            src={review.expert.image}
                            alt={review.expert.nickname}
                            className="rounded-circle me-3"
                            width="50"
                            height="50"
                          />
                          <div className="w-100">
                            <div className="flex align-items-center justify-content-between">
                              <h6 className="mb-1 cl_black">
                                {review.expert.nickname}
                              </h6>
                              <small className="text-muted">
                                {formatDate(review.date)}
                              </small>
                            </div>
                            <small className="text-muted flex gap-6p flex-wrap">
                              {review.expert.expertises &&
                              Array.isArray(review.expert.expertises) ? (
                                review.expert.expertises.map(
                                  (expertise, index) => (
                                    <p
                                      key={index}
                                      className="badge bg-info-transparent fs-11 rounded-1 mb-0"
                                    >
                                      {expertise}
                                    </p>
                                  ),
                                )
                              ) : (
                                <p className="badge bg-info-transparent fs-11 rounded-1 mb-0">
                                  {review.expert.expertises}
                                </p>
                              )}
                            </small>
                          </div>
                        </div>

                        <div className="">
                          <p className="text-muted">
                            {review.content.length > 100
                              ? review.content.substring(0, 100) + "..."
                              : review.content}
                          </p>
                        </div>

                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                          <div className="d-flex align-items-center flex-wrap justify-content-between w-100">
                            <div className="text-warning">
                              {[
                                ...Array(Math.floor(Number(review.rating))),
                              ].map((_, i) => (
                                <i
                                  className="bi bi-star-fill"
                                  key={`full-${i}`}
                                ></i>
                              ))}

                              {Number(review.rating) % 1 !== 0 && (
                                <i className="bi bi-star-half"></i>
                              )}

                              {[
                                ...Array(
                                  5 -
                                    Math.floor(Number(review.rating)) -
                                    (Number(review.rating) % 1 !== 0 ? 1 : 0),
                                ),
                              ].map((_, i) => (
                                <i
                                  className="bi bi-star"
                                  key={`empty-${i}`}
                                ></i>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>

          <div className="d-flex justify-content-center mt-4">
            <nav>
              <ul className="pagination">
                {Array.from({ length: totalPages }).map((_, index) => (
                  <li key={index}>
                    <button
                      data-interaction="paginate_button"
                      onClick={() => paginate(index + 1)}
                      className="btn me-2"
                      style={{
                        backgroundColor:
                          currentPage === index + 1
                            ? "rgba(142, 84, 233 , 0.3)"
                            : "",
                        borderColor:
                          currentPage === index + 1
                            ? "rgba(142, 84, 233 , 0.3)"
                            : "",
                      }}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title className="h6">
            {isAddNew ? languageData.add || "Add Review" : "Review Details"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isAddNew ? (
            <Form>
              <Form.Group controlId="expert" className="mb-3">
                <Form.Label>Expert</Form.Label>
                <Select
                components={{ Control }}
                  name="experts_list"
                  options={expertList}
                  isLoading={expertsLoading}
                  placeholder={languageData.select_expert}
                  noOptionsMessage={() =>
                    expertsLoading ? (
                      <LoadingSpinner />
                    ) : (
                      `${languageData.no_expert}`
                    )
                  }
                  loadingMessage={() => <LoadingSpinner />}
                  value={expertList.find(
                    (option) => option.value === reviewForm.expert_id,
                  )}
                  onChange={(selectedOption) =>{
                    setReviewForm((prev) => ({
                      ...prev,
                      expert_id: selectedOption.value,
                    }));
                  }}
                  formatOptionLabel={(option) => (
                    <div className="flex align-items-center gap-8p">
                      {option.image ? (
                        <img
                          className="img_app"
                          src={option.image}
                          alt={option.label}
                        />
                      ) : (
                        <div className="label_exp" />
                      )}

                      <span>{option.label}</span>
                    </div>
                  )}
                  
                />
              </Form.Group>

              <Form.Group controlId="comment" className="mb-3">
                <Form.Label>{languageData.comment}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={6}
                  placeholder={languageData.addYourComment}
                  name="comment"
                  value={reviewForm.content}
                  onChange={(e) =>
                    setReviewForm((prev) => ({
                      ...prev,
                      content: e.target.value,
                    }))
                  }
                />
              </Form.Group>

              <Form.Group controlId="rating" className="mb-3">
                <Form.Label>{languageData.rating}</Form.Label>
                <div className="d-flex align-items-center">
                  <div className="text-warning">
                    {[...Array(5)].map((_, i) => {
                      let icon = "bi-star";

                      if (rating >= i + 1) {
                        icon = "bi-star-fill";
                      } else if (rating >= i + 0.5) {
                        icon = "bi-star-half";
                      }

                      return (
                        <a data-interaction="rating_for_comment"
                         data-tooltip-id="add_stars"
                  data-tooltip-content={
                    languageData.stars_tooltip
                  }
                  data-tooltip-place="bottom"
                  >
                      <Tooltip id="add_stars" />
                          <i
                            key={i}
                            className={`bi ${icon} fs-22 pointer`}
                            onClick={() => handleStarClick(i)}
                            style={{
                              color: rating >= i + 0.5 ? "#ff8a00" : "#d0d0d0",
                            }}
                          />
                        </a>
                      );
                    })}
                  </div>
                </div>
              </Form.Group>
            </Form>
          ) : selectedReview ? (
            <div>
              <div className="d-flex align-items-center mb-3">
                <img
                  src={selectedReview.expert.image}
                  alt={selectedReview.expert.nickname}
                  className="rounded-circle me-2"
                  width="60"
                  height="60"
                />
                <div className="text-start">
                  <h6>{selectedReview.expert.nickname}</h6>
                  <small>
                    {Array.isArray(selectedReview.expert.expertises)
                      ? selectedReview.expert.expertises.join(", ")
                      : selectedReview.expert.expertises}
                  </small>
                </div>
              </div>

              <div className="text-start mb-3">
                <p>{selectedReview.content}</p>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <span className="me-2">{languageData.rating}</span>
                  <div className="text-warning">
                    {[...Array(selectedReview.rating)].map((_, i) => (
                      <i className="bi bi-star-fill" key={i}></i>
                    ))}
                    {[...Array(5 - selectedReview.rating)].map((_, i) => (
                      <i
                        className="bi bi-star"
                        key={i + selectedReview.rating}
                      ></i>
                    ))}
                  </div>
                </div>
                <span className="text-muted">
                  {formatDate(selectedReview.date)}
                </span>
              </div>
            </div>
          ) : (
            <div>{languageData.not_available}</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            data-interaction="close_modaladd_comment"
            className="close_modal_btn"
            onClick={closeModal}
          >
            {languageData.close || "Close"}
          </Button>
          {isAddNew && (
            <Button
              variant="primary"
              onClick={handleSaveReview}
              data-interaction="confirm_add_comment_button"
            >
              {languageData.save || "Save"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      {/* Spinner Overlay */}
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default ContentComments;
